module.exports = __webpack_public_path__ + "static/media/office.1e9a4e98.svg";